import type {TDashboardDataResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import {GetApi} from '~/api/client'
import dashboardDataMock from '~/api/endpoints/dashboard/GetDashboardData/mock'

const endpoint = endpoints.dashboard.dashboardData

export default class GetDashboardData extends GetApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  public static mockResponseWithMockConfig = () => {
    // TODO eventually configure the response here with MockConfig
    return dashboardDataMock
  }

  protected getMockResponse(): TDashboardDataResponse {
    return GetDashboardData.mockResponseWithMockConfig()
  }

  protected transformResponse(r: TDashboardDataResponse) {
    return r
  }

  public mocksRequireLogin() {
    return true
  }
}
